import { guid } from '../../../../utils/guid'
import { FormItemType } from '../../../../form/props/form-item/default.js'
import { ShopFieldNames } from '../../../../model/shop'
import translator from '../../../../translate'
import { FormInputType } from '../../../../form/props/form-item/input'

const FormItemSubject = {
  id: guid().uid(),
  attribute: ShopFieldNames.SUBJECT,
  label: translator._('shop.subject'),
  type: FormItemType.TEXTAREA,
  required: true,
  disabled: false,
  hidden: false,
  inputType: FormInputType.TEXT,
}

export default FormItemSubject
